import type { HotToastService } from "@ngxpert/hot-toast";
import type { MonoTypeOperatorFunction } from "rxjs";
import { tap } from "rxjs/operators";

type ShowToastOperatorCommonKeysOption = {
    messageKey: string;
    params?: object;
};

type ShowToastOperatorOption = {
    message: { success: string; error: string };
    params?: object;
};

export type ShowSuccessOrErrorToastOperatorOptions = ShowToastOperatorCommonKeysOption | ShowToastOperatorOption;

export function showSuccessOrErrorToast<T>(
    toast: HotToastService,
    options: ShowSuccessOrErrorToastOperatorOptions
): MonoTypeOperatorFunction<T> {
    return (source) =>
        source.pipe(
            tap({
                next: () => {
                    const message = transformOptions(options, "success");
                    toast.success(message, options.params);
                },
                error: () => {
                    const message = transformOptions(options, "error");
                    toast.error(message, options.params);
                }
            })
        );
}

function transformOptions(options: ShowSuccessOrErrorToastOperatorOptions, type: "error" | "success"): string {
    if ("messageKey" in options) {
        return `${options.messageKey}.${type}`;
    }

    return options.message[type];
}
